<template>
  <button
    class="relative w-40 h-24 rounded-full transition-all"
    :class="{
      'bg-mintPrimary': selected,
      'bg-light': !selected
    }"
    @click="toggle"
  >
    <div
      class="w-20 h-20 absolute bg-lightest top-2 rounded-full transition-all"
      :class="{
        'left-[18px]': selected,
        'left-2': !selected
      }"
    >
      <div v-if="design === 'gift'" class="flex items-center h-full w-full justify-center">
        <img
          src="/icons/gift.svg"
          class="w-[15px] relative top-[-1px] left-[-0.6px]"
          alt=""
        >
      </div>
    </div>
  </button>
</template>

<script setup lang="ts">
type Props = {
  selected: boolean,
  design?: 'standard' | 'gift',
}

const props = withDefaults(defineProps<Props>(), {
  design: 'standard',
});

const emit = defineEmits<{
  (e: 'set', payload: boolean): void;
}>();

const toggle = () => {
  emit('set', !props.selected);
};

</script>

<style scoped lang="postcss">
</style>
